import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-support-us',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    RouterLink
  ],
  templateUrl: './support-us.component.html',
  styleUrl: './support-us.component.scss'
})
export class SupportUsComponent {

  public readonly routes = {
    about: RouteGenerator.abs(UI_ROUTES.public.about)
  };
}
